"use client";

import { useEffect } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { HeroSection } from "../components/HeroSection";
import { FeaturesSection } from "../components/FeaturesSection";
import { FAQSection } from "../components/FAQSection";
import { ContactSection } from "../components/ContactSection";
import styles from "./page.module.css";

export default function HomePage() {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  
  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      if (hash === "#contact") {
        scrollToContact();
      }
    }
  }, []);

  return (
    <div className={styles.homeRoot}>
      <Header onContactClick={scrollToContact} />
      <HeroSection onContactClick={scrollToContact} />
      <FeaturesSection onContactClick={scrollToContact} />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
